module.exports = __webpack_public_path__ + "Flag-496.d7869a457969cdeff601694ba366f28e.svg";